import { Stack, Typography } from '@mui/material';
import classNames from 'classnames';

import { CopyToClipboardWrapper } from '../buttons/copyToClipboardButton';
import { OverflowTooltip } from '../tooltips/overflowTooltip';

export const TextDetailsTuple = ({
  primaryProp,
  onPrimaryClick,
  secondaryProp,
  onSecondaryClick,
  enableSameValue = false,
  sameColor = false,
  copyable = false,
}: {
  primaryProp?: string;
  onPrimaryClick?: () => void;
  secondaryProp?: string;
  onSecondaryClick?: () => void;
  enableSameValue?: boolean;
  sameColor?: boolean;
  copyable?: boolean;
}) => {
  return (
    <Stack gap={copyable ? undefined : '4px'} overflow='hidden'>
      <PrimaryProp
        onClick={onPrimaryClick}
        primaryProp={primaryProp}
        copyable={copyable}
      />
      <SecondaryProp
        onClick={onSecondaryClick}
        secondaryProp={secondaryProp}
        primaryProp={primaryProp}
        enableSameValue={enableSameValue}
        sameColor={sameColor}
        copyable={copyable}
      />
    </Stack>
  );
};

const PrimaryProp = ({
  primaryProp,
  onClick,
  copyable,
}: {
  primaryProp?: string;
  onClick?: () => void;
  copyable: boolean;
}) => {
  if (!primaryProp) return null;

  return !copyable ? (
    <OverflowTooltip text={primaryProp} onClick={onClick} />
  ) : (
    <CopyToClipboardWrapper textToCopy={primaryProp}>
      <OverflowTooltip text={primaryProp} onClick={onClick} />
    </CopyToClipboardWrapper>
  );
};

const SecondaryProp = ({
  secondaryProp,
  primaryProp,
  onClick,
  enableSameValue,
  sameColor,
  copyable,
}: {
  secondaryProp?: string;
  primaryProp?: string;
  onClick?: () => void;
  enableSameValue?: boolean;
  sameColor?: boolean;
  copyable?: boolean;
}) => {
  if (!secondaryProp || (!enableSameValue && primaryProp === secondaryProp)) {
    return null;
  }

  const content = (
    <OverflowTooltip
      text={secondaryProp}
      onClick={onClick}
      renderContent={(text, ref) => (
        <Typography
          ref={ref}
          variant={primaryProp ? 'body2' : 'subtitle1'}
          color={
            primaryProp && !sameColor
              ? 'var(--mui-palette-text-secondary) !important'
              : 'text.primary'
          }
          className={classNames('truncate', {
            'underline hover:cursor-pointer hover:text-[var(--mui-palette-text-secondary)]':
              onClick,
          })}
        >
          {text}
        </Typography>
      )}
    />
  );

  if (!copyable) return content;

  return (
    <CopyToClipboardWrapper textToCopy={secondaryProp}>
      {content}
    </CopyToClipboardWrapper>
  );
};
